import React from 'react';
import { FaWhatsapp } from 'react-icons/fa';
import './WhatsAppButton.css';

const WhatsAppButton = ({ phoneNumber, message, onContactClick }) => {
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

  const handleClick = () => {
    // Llamar a la función de seguimiento antes de redirigir
    if (onContactClick) {
      onContactClick();
    }
    // Redirigir al usuario a WhatsApp
    window.open(whatsappUrl, '_blank', 'noopener,noreferrer');
  };

  return (
    <button className="whatsapp-button" onClick={handleClick}>
      <FaWhatsapp size={28} />
    </button>
  );
};

export default WhatsAppButton;